import { useProfileLoginStore } from '~/store/profileLogin';

export default defineNuxtPlugin((nuxt) => {
  nuxt.hook('app:beforeMount', () => {
    const profileLoginStore = useProfileLoginStore();
    const companyLogin = reactive({
      access: false,
      adminLink: '',
      adminLinkText: ''
    });

    const updateCompanyLogin = (data) => {
      if (data && data.value && data.value.corporate_status) {
        companyLogin.access = data.value.corporate_status.access;
        companyLogin.adminLink = data.value.corporate_status.admin_link;
        companyLogin.adminLinkText = data.value.corporate_status.admin_text;
        profileLoginStore.setCompanyLogin(companyLogin);
      }
    };

    const handleLocalStorageData = () => {
      const storedData = localStorage.getItem('sub-corporate-admin-access');
      if (storedData) {
        const parsedData = JSON.parse(storedData);
        updateCompanyLogin(parsedData);
      }
    };

    useEventListener(window, 'sub-corporate-admin-access', (event) => {
      updateCompanyLogin(event.value);
    });

    handleLocalStorageData();
  });
});
